import {bindFilterButtons, bindWindowResize} from "./overview-filters";
import { registerPaginationTriggers } from "./overview-pagination";
import { bindGenericPopups } from "./generic-popup";
import { bindJobAlertPopup, bindJobAlertSubmit} from "./job-alert";
//import "./mobile-vop-search"; Due to deadline this feature is now disabled (NOt DONE YET)
const initialize = () => {
	bindFilterButtons();
	registerPaginationTriggers();
	bindJobAlertPopup();
	bindJobAlertSubmit();
	bindGenericPopups();
	bindWindowResize();
}

initialize();
